// extracted by mini-css-extract-plugin
export default {"container":"CellWrapper_container__Mfl2q"};